module.exports = __webpack_public_path__ + "img/bg-l.60d94bb4.png";